// extracted by mini-css-extract-plugin
export default {"botaoLixeira":"BotaoBoletoDeletar_botaoLixeira__x01BG"};